// import Auth, { history, Database } from 'outlier-auth/dist/main';
import authentication from 'react-azure-b2c';


// const localUri = process.env.NODE_ENV === "development" ? 'https://localhost:56220' : "https://estudiopineda.cl";
const apiUrl = '/api/';

// var authConfig = {
// 	issuer: 'https://estudiopineda.b2clogin.com/estudiopineda.onmicrosoft.com/B2C_1_pineda_login/v2.0/.well-known/openid-configuration',
// 	authority: 'https://estudiopineda.b2clogin.com/estudiopineda.onmicrosoft.com/B2C_1_pineda_login/v2.0/.well-known/openid-configuration',
// 	client_id	: 'e613efed-3fb1-465d-b2cd-ca1889e1ece1',
// 	redirect_uri: `${localUri}/callback`,
// 	silent_redirect_uri: `${localUri}/silent-refresh`,
// 	post_logout_redirect_uri: `${localUri}/signout`,
// 	response_type: 'code',
// 	scope: 'https://estudiopineda.onmicrosoft.com/authentication/User.Read',
// 	automaticSilentRenew: false,
// 	loadUserInfo: true,
// 	autoSignIn: true,
// 	meta: {}
// };

authentication.initialize({
	instance: 'https://login.microsoftonline.com/tfp/',
	tenant: 'estudiopineda.onmicrosoft.com',
	signInPolicy: 'B2C_1_pineda_login',
	clientId: 'e613efed-3fb1-465d-b2cd-ca1889e1ece1',
	cacheLocation: 'sessionStorage',
	scopes: ['https://estudiopineda.onmicrosoft.com/authentication/User.Read'],
	redirectUri: window.location.origin,
	postLogoutRedirectUri: window.location.origin
});

var db;

// var appAuth = new Auth({ log: false, authConfig, history, homeUri: '/reports', loginUri: '/', callbacks: {
// 	onError: console.error,
// 	onRenewError: err => {
// 		console.log('Auth.onRenewError');
// 		console.log(err);
// 	}
// }});

// db = new Database({
// 	apiUrl,
// 	appAuth,
// 	onTokenError: console.error,
// 	onError: (err) => {
// 		console.error(`error auth.db ${err}`);
// 	}
// });

// export { appAuth, db, apiUrl };
export { db, apiUrl };
